module.exports = __webpack_public_path__ + "static/ibgs-og-breit.dd36fb18.png";


//////////////////
// WEBPACK FOOTER
// ./static/ibgs-og-breit.png
// module id = 577
// module chunks = 114276838955818